import TradingOfferDetail from 'modules/trading/pages/TradingOfferDetail';
import { TradingOfferDetailProvider } from '../contexts/TradingOfferDetailContext';

const TradingOfferDetailContainer = () => (
  <TradingOfferDetailProvider>
    <TradingOfferDetail />
  </TradingOfferDetailProvider>
);

export default TradingOfferDetailContainer;
